<template>
  <div class="summary" v-if="summaryItems.length > 0">
    <p class="summary__title">Aktive søgekriterier</p>
    <div class="summary__item-container">
      <span
        class="summary__item"
        v-for="(summaryItem, index) in summaryItems"
        :key="index + summaryItem.name"
      >
        <p v-html="summaryItem.name"></p>
        <button
          class="summary__item-button"
          type="button"
          @click.prevent="summaryItem.clearSelf(summaryItem)"
        >
          <div class="icon--plus icon--rotate icon--small"></div>
        </button>
      </span>
      <button class="summary__clear-all" @click.prevent="clearAll">
        Ryd alle
      </button>
    </div>
  </div>
</template>

<script>
import { nextTick } from 'vue'

export default {
  name: 'Summary',
  props: {
    summaryItems: { default: null, type: Array },
  },
  methods: {
    clearAll() {
      this.summaryItems.forEach(item => {
        nextTick(() => {
          item.clearSelf(item)
        })
      })
    },
  },
}
</script>

<style lang="scss">
@import 'Summary.scss';
</style>
